<div class="flex min-h-screen flex-col bg-cp-gray-100 text-cp-primary-100">
  <header class="relative flex h-14 shrink-0 items-center gap-4 bg-cp-primary-100 px-5 text-white">
    <a routerLink="/" class="flex items-center gap-3 no-underline" aria-label="ChargeIT Auth home">
      <img src="chargeit-logo.svg" alt="chargeIT" class="h-7 w-auto select-none" />
      <span class="rounded-md bg-white/10 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-white/80">Auth</span>
    </a>

    @if (authenticated()) {
      <nav class="app-switch absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" aria-label="Sections">
        <a routerLink="/management" routerLinkActive="app-switch-active" class="app-switch-item">
          <mat-icon>groups</mat-icon> Tenants &amp; users
        </a>
        <a routerLink="/permissions" routerLinkActive="app-switch-active" class="app-switch-item">
          <mat-icon>admin_panel_settings</mat-icon> Permissions
        </a>
      </nav>
    }

    <div class="flex-1"></div>

    @if (authenticated()) {
      <span class="text-sm text-white/70"
        >Signed in as <strong class="text-white">{{ username() }}</strong></span
      >
      <button
        type="button"
        (click)="logout()"
        class="rounded-md bg-white/10 px-3.5 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/20"
      >
        Logout
      </button>
    } @else {
      <button
        type="button"
        (click)="login()"
        class="rounded-md bg-white/10 px-3.5 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/20"
      >
        Login
      </button>
    }
  </header>

  <section class="min-h-0 flex-1">
    @if (authenticated()) {
      <router-outlet />
    } @else {
      <p class="mt-16 text-center text-cp-primary-60">Redirecting to Keycloak</p>
    }
  </section>
</div>
